document.addEventListener("DOMContentLoaded", function () {
  const productForm = document.querySelector(".product_form");
  if(productForm){
  const submitButton = productForm.querySelector(".bulk-add-to-cart-button");
  const submitMessageElement = productForm.querySelector(".form-submission-message");
  const originalButtonText = submitButton.innerHTML;
  const spinnerHTML = '<div class="spinner"></div>';
  const cartCountElements = document.querySelectorAll("cart-count");

  const quantityInputs = document.querySelectorAll(".bulk-quantity-selector");

  // Translated strings, supplied by snippets/bulk-add-to-cart-b2b.liquid.
  const strings = {
    labelDefault: submitButton.dataset.labelDefault || originalButtonText.trim(),
    labelEmpty: submitButton.dataset.labelEmpty || "Select at least 1 variant",
    added: submitButton.dataset.messageAdded || "Added item(s) to the cart.",
    error:
      submitButton.dataset.messageError ||
      "Could not add selected item(s) to the cart because of an error.",
    capped:
      submitButton.dataset.messageCapped ||
      "Quantity for [variant] was reduced to [max], the most we have in stock."
  };

  /**
   * Announce a message without changing what is on screen.
   * submitMessageElement carries role="status" in the markup.
   */
  function announce(message) {
    if (!submitMessageElement) return;
    submitMessageElement.textContent = "";
    window.setTimeout(function () {
      submitMessageElement.textContent = message;
    }, 60);
  }

  function updateSubmitButtonState() {
    let hasValidQuantity = false;

    quantityInputs.forEach(function (input) {
      if (parseInt(input.value) > 0) {
        hasValidQuantity = true;
      }
    });

    // a11y: aria-disabled rather than the disabled property. A disabled button is
    // removed from the tab order, so the one explanation of why the user is stuck
    // ("Select at least 1 variant") could never be reached by keyboard. The button
    // stays focusable and the submit handler rejects the empty case instead.
    submitButton.setAttribute("aria-disabled", String(!hasValidQuantity));
    submitButton.textContent = hasValidQuantity
      ? strings.labelDefault
      : strings.labelEmpty;
  }

  quantityInputs.forEach(function (input) {
    input.addEventListener("change", function (event) {
      const max = parseInt(input.getAttribute("max"));
      const value = parseInt(input.value);
      const variantIdMatch = input.id.match(/\d+/);
      if (!variantIdMatch) return;
      const variantId = variantIdMatch[0];
      const hiddenInput = document.querySelector(`input[type="hidden"][value="${variantId}"]`);
      if (!hiddenInput) return;

      if (!isNaN(max) && value > max) {
        input.value = max;
        // a11y: the value was previously rewritten in silence. Say so — a sighted
        // user sees the number change, everyone else got no signal at all.
        announce(
          strings.capped
            .replace("[variant]", input.getAttribute("aria-label") || "")
            .replace("[max]", String(max))
        );
      }

      if (input.value > 0) {
        hiddenInput.setAttribute("selected", "selected");
      } else {
        hiddenInput.removeAttribute("selected");
      }

      updateSubmitButtonState();
    });
  });

  updateSubmitButtonState();

  productForm.addEventListener("submit", function (event) {
    event.preventDefault();

    // The button is no longer natively disabled, so reject the empty case here.
    if (submitButton.getAttribute("aria-disabled") === "true") {
      announce(strings.labelEmpty);
      return;
    }

    let submitMessage = strings.added;
    let submitMessageClass = "form-submission-message--success";

    submitButton.setAttribute("aria-disabled", "true");
    // aria-busy so the button is not briefly nameless while it shows a spinner.
    submitButton.setAttribute("aria-busy", "true");
    submitButton.innerHTML = spinnerHTML;

    const selectedVariants = [];

    document.querySelectorAll('input[type="hidden"][selected="selected"]').forEach(function (hiddenInput) {
      const variantId = hiddenInput.value;
      const quantityInput = document.querySelector(`#quantity_${variantId}`);
      const quantity = parseInt(quantityInput.value);

      if (quantity > 0) {
        selectedVariants.push({ id: variantId, quantity: quantity });
      }
    });

    if (selectedVariants.length === 0) {
      // Was a native alert() with hardcoded English. The status region reaches
      // assistive tech and stays on the page where the message belongs.
      announce(strings.labelEmpty);
      submitButton.removeAttribute("aria-busy");
      submitButton.textContent = strings.labelDefault;
      updateSubmitButtonState();
      return;
    }

    const requestData = {
      items: selectedVariants.map((variant) => {
        return {
          id: variant.id,
          quantity: variant.quantity
        };
      })
    };

    console.log("Request data:", requestData);

    fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json;"
      },
      body: JSON.stringify(requestData)
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Cart update response:", data);

        if (data.status == 422) {
          submitMessage = data.message + " - " + data.description;
          submitMessageClass = "form-submission-message--error";
        } else {
          fetch("/cart.js", {
            method: "GET",
            credentials: "same-origin",
            headers: {
              "X-Requested-With": "XMLHttpRequest"
            }
          })
            .then((response) => response.json())
            .then((cartData) => {
              cartCountElements.forEach(cartCountElement => {
                cartCountElement.innerHTML = cartData.item_count;
                cartCountElement.setAttribute('data-cart-count', cartData.item_count);
              });
            })
            .catch((error) => {
              console.error("Error fetching cart data:", error);
            });
        }
      })
      .catch((error) => {
        console.error("Error adding items to cart:", error);
        submitMessage = strings.error;
        submitMessageClass = "form-submission-message--error";
      })
      .finally(() => {
        submitButton.removeAttribute("aria-busy");
        submitButton.textContent = strings.labelDefault;
        submitMessageElement.classList.add(submitMessageClass);
        // textContent, and set after a tick, so the live region reliably fires.
        submitMessageElement.textContent = "";
        window.setTimeout(() => {
          submitMessageElement.textContent = submitMessage;
        }, 60);

        setTimeout(() => {
          submitMessageElement.textContent = "";
          submitMessageElement.classList.remove(submitMessageClass);
        }, 5000);

        quantityInputs.forEach(function (input) {
          input.value = "0";
          input.dispatchEvent(new Event("change")); // Trigger the change event to update hidden fields
        });

        // Update the submit button state after resetting the inputs
        updateSubmitButtonState();
      });
  });  
  }
});


